import { DateFilterName } from "app/shared/enums";
import { Utility } from "app/utilities";

export type tFilterType = 'today' | 'week' | 'month' | 'year' | 'custom';

export type tFilter = {name: DateFilterName, value: tFilterType}

export class DateFilterRequestModel {
    startDate?: Date | null;
    endDate?: Date | null;
    filterType: tFilterType = 'month';

    constructor(init?: Partial<DateFilterModel>) {
        if (init) {
            this.startDate = init.startDateString;
            this.endDate = init.endDateString;
            this.filterType = init.filterType ?? 'month';
        }
    }
}

export class DateFilterModel extends DateFilterRequestModel {
    selected?: string | null;
    
    name!: DateFilterName;

    get startDateString() {
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);

        return Utility.convertDateToString(this.startDate ?? oneWeekAgo) as any;
    }

    get endDateString() {
        return Utility.convertDateToString(this.endDate ?? new Date()) as any;
    }

    constructor(init?: Partial<DateFilterModel>) {
        super();
        if (init) {
            Object.assign(this, init);
        }
    }
}
